import {ITableColumn} from '../../../components/AppDataTable'

export type incidentListReportType = {id: string; label: string; fileName: string; date: string}

export interface IincidentReportList {
  events: string
  checkpoints: string
  noOfEvents: number
}
export interface IincidentReportColumn extends ITableColumn {
  field: keyof IincidentReportList
}
export const incidentReportcolumn: IincidentReportColumn[] = [
  {field: 'events', headerText: 'Events', width: '200'},
  {field: 'checkpoints', headerText: 'Check Point', width: '200'},
  {field: 'noOfEvents', headerText: 'No. of Events', width: '200'},
]

export type reportListTypeFromServer = {
  id: string
  report_type: string
  upload_date: string
  filepath: string
  filename: string
}

export type eventLogType = {
  Date: string // Timestamp in "DD-MM-YYYY HH:MM:SS" format
  'Event Type': string // Type of event, e.g., "MME" or "INCIDENT"
  'Event Details': string // Details about the event
  'Check Point': string // Checkpoint information, which could be empty
  'Tour ID': string // Tour ID, represented as a string
  'Guard Name': string // Name and identifier of the guard
}

export type uploadIncidentExcelDataResponseType = {
  id: string
  shiftname: string
  data: eventLogType[]
}

export type uploadIncidentResponseDataType = {
  excelData: uploadIncidentExcelDataResponseType
  uploadedReport: reportListTypeFromServer
}

export type uploadIncidentReportResponse = {
  success: boolean
  data: uploadIncidentResponseDataType
  message: string
}

export type readIncidentReportsForGraphResponseType = {
  success: boolean
  data: eventLogType[]
}
